import { createStyles } from '@/styles';

export default createStyles(() => ({
  classes: {
    wrapper: 'fixed flex top-0 left-0 right-0 bottom-0 p-2',
    dropzone: 'flex-1',
  },
  styles: {
    dropzone: {},
    wrapper: {},
  },
}));
